import { render, staticRenderFns } from "./sso-confirmation-popup.vue?vue&type=template&id=90031fb4&scoped=true&"
import script from "./sso-confirmation-popup.ts?vue&type=script&lang=ts&"
export * from "./sso-confirmation-popup.ts?vue&type=script&lang=ts&"
import style0 from "./sso-confirmation-popup.scss?vue&type=style&index=0&id=90031fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90031fb4",
  null
  
)

export default component.exports